// src/components/Notifications.js
import React from "react";
import { Snackbar, Alert } from "@mui/material";

const Notifications = ({
  snackbar,
  handleSnackbarClose,
  primaryBlue,
  glassStyles,
}) => {
  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Alert
        onClose={handleSnackbarClose}
        severity="success"
        sx={{
          width: "100%",
          ...glassStyles,
          bgcolor: "rgba(76, 175, 80, 0.9)",
          color: "white",
          fontWeight: 600,
          "& .MuiAlert-icon": {
            color: "white",
          },
        }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default Notifications;
